<!--<ng-template #recursiveList let-tree>-->
<!--  <div class="tree" *ngFor="let item of tree">-->
<!--    <div class="tree-title">-->
<!--      <mat-icon (click)="item.expand = !item.expand">-->
<!--        {{ item.expand ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}-->
<!--      </mat-icon>-->
<!--      <b>{{ item.code }}</b>-->

<!--    </div>-->
<!--    <div class="tree" *ngIf="item.children.length > 0 && item.expand" style="margin-left: 20px;">-->
<!--      <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: item.children }"></ng-container>-->
<!--    </div>-->
<!--  </div>-->
<!--</ng-template>-->
<!--<ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: tree }"></ng-container>-->
<div class="tree">
  <ng-template #recursiveList let-tree let-parent="parent">
    <div class="tree-item" *ngFor="let item of tree">
      <div class="tree-header">
        <div>
          <mat-icon (click)="item.expand = !item.expand" *ngIf="item?.code !== 'DS'">
            {{ item.expand ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
          </mat-icon>
          <mat-icon *ngIf="item.code === 'DS'">
            arrow_right
          </mat-icon>
        </div>
        <div style="font-weight: bold;">
          {{ item.code }}
        </div>
        <div style="margin-left: 10px;" *ngIf="item.level !== 0">
          {{ item.sales?.firstName === null ? '' : item.sales.firstName + ' ' + item.sales.lastName}}
          <!-- {{ item.sales ? item.sales.firstName + ' ' + item.sales.lastName : '-'}} -->
        </div>
        <!-- <div style="margin-left: 10px; font-size: 14px;" *ngIf="item.level !== 0 && action === ''">
          <a href="javascript:void(0)" (click)="onAddTeam(item, parent)">
            {{ (item?.code !== 'DS') ? 'เพิ่มสายงาน' : 'เพิ่มพนักงานขาย' }}
          </a>
          /
          <a href="javascript:void(0)" (click)="onEditSales(item, parent)">
            แก้ไขบุคคล
          </a>
          /
          <a *ngIf="mode === 'edit' && item.sales" href="javascript:void(0)" (click)="onTransferTeam(item, parent)">
            ย้ายสายงาน
          </a>
          <span *ngIf="mode === 'edit' && item.sales">/</span>
          <a href="javascript:void(0)" (click)="onDeleteTeam(item, parent)">
            ลบ
          </a>
        </div> -->
        <!-- <div *ngIf="action === 'transfer' && item.level !== 0 && item?.code !== 'DS'" style="margin-left: 10px;">
          <a href="javascript:void(0)" (click)="onSelectTeam(item)">
            ย้าย
          </a>
        </div> -->
      </div>
      <div class="tree-children" *ngIf="item.children.length > 0 && item.expand">
        <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: item.children, parent: item }"></ng-container>
      </div>
    </div>
  </ng-template>
  <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: tree, parent: null }"></ng-container>
</div>
